import React, { useEffect, useState } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const TrendingProduct = ({ image, type }) => {
  return (
    <div className="flex flex-col items-center justify-center text-center p-4">
      {/* Larger Square Image */}
      <div className="w-64 h-64 overflow-hidden rounded-lg shadow-md">
        <img
          src={image}
          alt="Product"
          className="w-full h-full object-cover"
        />
      </div>
      {/* Type Badge */}
      <span
        className={`px-3 py-1 mt-4 rounded-full text-sm font-semibold ${
          type === 'trending'
            ? 'bg-purple-100 text-purple-800'
            : 'bg-amber-100 text-amber-800'
        }`}
      >
        {type.charAt(0).toUpperCase() + type.slice(1)}
      </span>
    </div>
  );
};

export default function TrendingProductsSection() {
  const [products, setProducts] = useState([]); 
  const [loading, setLoading] = useState(true); 
  const [error, setError] = useState(null); 

  const API_BASE_URL = process.env.REACT_APP_BACKEND_URL;


  useEffect(() => {
    const fetchFeaturedProducts = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/list-featured`);
        if (!response.ok) {
          throw new Error('Failed to fetch featured products');
        }
        const data = await response.json();
        setProducts(data.featured_products); // Update state with fetched products
      } catch (err) {
        setError(err.message); // Set error message if API call fails
      } finally {
        setLoading(false); // Mark loading as complete
      }
    };

    fetchFeaturedProducts(); // Call the function to fetch data
  }, []);

  // Carousel settings with auto-sliding
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3, // Show 3 products at a time
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: '60px',
    autoplay: true, // Enable auto-sliding
    autoplaySpeed: 2000, // Auto-slide every 3 seconds
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          centerPadding: '40px',
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerPadding: '20px',
        },
      },
    ],
  };

  // Handle loading state
  if (loading) {
    return <p className="text-center text-gray-500">Loading featured products...</p>;
  }

  // Handle error state
  if (error) {
    return <p className="text-center text-red-500">Error: {error}</p>;
  }

  return (
    <section className="py-12 px-4 md:px-8 max-w-7xl mx-auto bg-gradient-to-b from-gray-50 to-white">
      {/* Section Header */}
      <div className="text-center mb-8">
        <h2 className="text-2xl md:text-4xl text-[#333333] mb-2 tracking-wide animate-pulse">
          Our Top Picks
        </h2>
        <p className="text-sm md:text-base text-gray-500 max-w-md mx-auto">
          Discover the fragrances that are trending and loved by all.
        </p>
        <div className="mt-4 h-1 w-20 bg-[#D4AF37] mx-auto rounded-full"></div>
      </div>

      {/* Carousel Display */}
      <Slider {...settings}>
        {products.length === 0 ? (
          <p className="text-center text-gray-500 col-span-full">No featured products available.</p>
        ) : (
          products.map((product) => (
            <TrendingProduct
              key={product.image} // Use image URL as a unique key
              image={product.image}
              type={product.type}
            />
          ))
        )}
      </Slider>
    </section>
  );
}
